import joi from 'joi';
import j2s from 'joi-to-swagger';
import type { SwaggerParameter, SwaggerParameterKind } from '../swagger.types';

/**
 * Describes the request parameters. Note: `contentType` is optional, however it will default to `application/json` is left empty
 * */
export interface QueryRequestBody {
	schema: joi.Schema;
	contentType?: string;
	description?: string;
	required?: boolean;
}

export const makeQueryParametersFromJoiObject = (options: QueryRequestBody) => {
	const swaggerSchema = j2s(options.schema).swagger as {
		properties: {
			[key: string]: {
				[key: string]: unknown;
			};
		};
	};

	return {
		requestBody: {
			...(options.hasOwnProperty('description') && { description: options.description }),
			...(options.hasOwnProperty('required') && { required: options.required }),
			content: {
				[options.contentType ? options.contentType : 'application/json']: {
					schema: swaggerSchema,
				},
			},
		},
	};
};

export interface SwaggerObject {
	schema: joi.Schema;
	paramsType: SwaggerParameterKind;
}

export const makeSwaggerParametersFromJoiObject = (params: SwaggerObject[]) => {
	let finalParameters = [];
	params.forEach((swaggerObject) => {
		const swaggerSchema = j2s(swaggerObject.schema).swagger as {
			properties: {
				[key: string]: {
					[key: string]: unknown;
				};
			};
		};
		finalParameters.push(
			...Object.entries(swaggerSchema.properties).reduce<SwaggerParameter[]>(
				(acc, [key, value]) => [
					...acc,
					{
						in: swaggerObject.paramsType,
						name: key,
						schema: value,
					},
				],
				[]
			)
		);
	});

	return finalParameters;
};
